import Vue from "vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import { PopupManager } from "element-ui/lib/utils/popup";

/**
 * The ImagePreviewer class provides a static method to preview a list of images.
 * It uses a modal viewer to display the images starting from a specified initial index.
 *
 * @example
 * await ImagePreviewer(['image1.jpg', 'image2.jpg', 'image3.jpg'], 0);
 */
export class ImagePreviewer {
  /**
   * The ImagePreviewer class provides a static method to preview a list of images.
   * It uses a modal viewer to display the images starting from a specified initial index.
   *
   * @example
   * await ImagePreviewer(['image1.jpg', 'image2.jpg', 'image3.jpg'], 0);
   */
  static open(images = [], initialIndex = 0) {
    return new Promise((resolve) => {
      // 手动提升全局 popup zIndex
      let zIndex = 0;
      if (PopupManager && typeof PopupManager.nextZIndex === "function") {
        zIndex = PopupManager.nextZIndex();
      }
      const ImageViewerConstructor = Vue.extend(ElImageViewer);
      const instance = new ImageViewerConstructor({
        propsData: {
          urlList: images,
          initialIndex,
          appendToBody: true,
          maskClosable: true,
          onClose: function () {
            instance.$destroy();
            if (instance.$el && instance.$el.parentNode) {
              instance.$el.parentNode.removeChild(instance.$el);
            }
            resolve();
          },
        },
      });
      instance.$mount();
      instance.$el.style.zIndex = zIndex; // 提升z-index
      console.log("zIndex:", zIndex);
      document.body.appendChild(instance.$el);
    });
  }
}

// Vue2 插件包装
export const ImagePreviewerPlugin = {
  install(Vue) {
    Vue.prototype.$imagePreviewer = ImagePreviewer.open;
  },
};
